// extracted by mini-css-extract-plugin
module.exports = {"content":"RemoveRentalModal_content__295hR"};